import { teApi } from 'yxt-biz-pc/packages/api';

// 获取讲师级别
export const getTeLevelList = (showNoClassification) => {
  return teApi.get(`level/list?showNoClassification=${showNoClassification || ''}`);
};
